import { observer } from 'mobx-react-lite'
import { FocusModeComponent } from 'app/components/action-center/FocusModeComponent'
import { useFocusQueue } from 'app/components/action-center/useFocusQueue'

const ActionCenterWorkPage = observer(function ActionCenterWorkPage() {
  const props = useFocusQueue()
  return <FocusModeComponent {...props} />
})

export default ActionCenterWorkPage
